export default __webpack_public_path__ + "static/media/ball_2.70313178.png";